export default __webpack_public_path__ + "images/62f143b2011a32419fe1bfa0d912a9cf.png";